var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#8E919A",
    strokeWidth: 1,
    fill: "#8E919A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.75,11.9375 C20.75,13.3905 16.59,17.1245 12,17.1245 C11.35,17.1245 10.711,17.0435 10.089,16.9115 L8.863,18.1365 C9.89,18.4405 10.952,18.6245 12,18.6245 C16.949,18.6245 22.25,14.6995 22.25,11.9375  C22.25,10.6225 21.041,9.0465 19.247,7.7525 L18.157,8.8435 C19.734,9.9485 20.75,11.2205 20.75,11.9375",
    fill: "#8E919A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25,11.9375 C3.25,10.4845 7.41,6.7505 12,6.7505 C12.675,6.7505 13.339,6.8385 13.983,6.9805 L15.206,5.7585 C14.158,5.4425 13.072,5.2505 12,5.2505  C7.051,5.2505 1.75,9.1755 1.75,11.9375 C1.75,13.2655 2.982,14.8595 4.805,16.1595 L5.895,15.0695 C4.287,13.9565 3.25,12.6625 3.25,11.9375",
    fill: "#8E919A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8213,9.1431 L13.1603,7.8041 C12.7893,7.6991 12.4043,7.6251 12.0003,7.6251 C9.6223,7.6251 7.6873,9.5601 7.6873,11.9371 C7.6873,12.3421 7.7613,12.7261  7.8663,13.0981 L9.2053,11.7591 C9.2963,10.3521 10.4153,9.2331 11.8213,9.1431",
    fill: "#8E919A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2783,14.7217 L10.9073,16.0927 C11.2583,16.1847  11.6203,16.2497 12.0003,16.2497 C14.3783,16.2497 16.3123,14.3157 16.3123,11.9377 C16.3123,11.5577 16.2473,11.1967 16.1543,10.8447 L14.7843,12.2157  C14.6523,13.5417 13.6043,14.5887 12.2783,14.7217",
    fill: "#8E919A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875,2 C12.3582492,2 12.75,2.39175084 12.75,2.875 L12.75,21.125  C12.75,21.6082492 12.3582492,22 11.875,22 C11.3917508,22 11,21.6082492 11,21.125 L11,2.875 C11,2.39175084 11.3917508,2 11.875,2 Z M11.875,3.5  C12.220178,3.5 12.5,3.22017797 12.5,2.875 L12.5,21.125 C12.5,20.779822 12.220178,20.5 11.875,20.5 C11.529822,20.5 11.25,20.779822 11.25,21.125 L11.25,2.875  C11.25,3.22017797 11.529822,3.5 11.875,3.5 Z",
    fill: "#8E919A",
    fillRule: "nonzero",
    transform: "translate(11.875000, 12.000000) rotate(45.000000)  translate(-11.875000, -12.000000) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEye);
export default __webpack_public_path__ + "static/media/close-eye.cc7adf8a6eec54029f71768ce54971b7.svg";
export { ForwardRef as ReactComponent };